import { render, staticRenderFns } from "./textPage.vue?vue&type=template&id=de52fef6"
import script from "./textPage.vue?vue&type=script&lang=js"
export * from "./textPage.vue?vue&type=script&lang=js"
import style0 from "./textPage.vue?vue&type=style&index=0&id=de52fef6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports